import { css } from '@linaria/core'

// Utilities for margin
export const elMAuto = css`
  margin: var(--util-auto);
`

export const elMxAuto = css`
  margin: var(--util-0) var(--util-auto);
`

export const elMyAuto = css`
  margin: var(--util-auto) var(--util-0);
`

export const elMlAuto = css`
  margin-left: var(--util-auto);
`

export const elMrAuto = css`
  margin-right: var(--util-auto);
`

export const elMtAuto = css`
  margin-top: var(--util-auto);
`

export const elMbAuto = css`
  margin-bottom: var(--util-auto);
`

export const elM0 = css`
  margin: var(--util-0);
`

export const elM1 = css`
  margin: var(--util-rems-1);
`

export const elM2 = css`
  margin: var(--util-rems-2);
`

export const elM3 = css`
  margin: var(--util-rems-3);
`

export const elM4 = css`
  margin: var(-util-rems-4);
`

export const elM5 = css`
  margin: var(--util-rems-5);
`

export const elM6 = css`
  margin: var(--util-rems-6);
`

export const elM7 = css`
  margin: var(--util-rems-7);
`

export const elM8 = css`
  margin: var(--util-rems-8);
`

export const elM9 = css`
  margin: va(--util-rems-9);
`

export const elM10 = css`
  margin: var(--util-rems-10);
`

export const elM11 = css`
  margin: var(--util-rems-11);
`

export const elM12 = css`
  margin: var(--util-rems-12);
`

export const elMl0 = css`
  margin-left: var(--util-0);
`

export const elMl1 = css`
  margin-left: var(--util-rems-1);
`

export const elMl2 = css`
  margin-left: var(--util-rems-2);
`

export const elMl3 = css`
  margin-left: var(--util-rems-3);
`

export const elMl4 = css`
  margin-left: var(-util-rems-4);
`

export const elMl5 = css`
  margin-left: var(--util-rems-5);
`

export const elMl6 = css`
  margin-left: var(--util-rems-6);
`

export const elMl7 = css`
  margin-left: var(--util-rems-7);
`

export const elMl8 = css`
  margin-left: var(--util-rems-8);
`

export const elMl9 = css`
  margin-left: var(--util-rems-9);
`

export const elMl10 = css`
  margin-left: var(--util-rems-10);
`

export const elMl11 = css`
  margin-left: var(--util-rems-11);
`

export const elMl12 = css`
  margin-left: var(--util-rems-12);
`

export const elMr0 = css`
  margin-right: var(--util-0);
`

export const elMr1 = css`
  margin-right: var(--util-rems-1);
`

export const elMr2 = css`
  margin-right: var(--util-rems-2);
`

export const elMr3 = css`
  margin-right: var(--util-rems-3);
`

export const elMr4 = css`
  margin-right: var(-util-rems-4);
`

export const elMr5 = css`
  margin-right: var(--util-rems-5);
`

export const elMr6 = css`
  margin-right: var(--util-rems-6);
`

export const elMr7 = css`
  margin-right: var(--util-rems-7);
`

export const elMr8 = css`
  margin-right: var(--util-rems-8);
`

export const elMr9 = css`
  margin-right: va(--util-rems-9);
`

export const elMr10 = css`
  margin-right: var(--util-rems-10);
`

export const elMr11 = css`
  margin-right: var(--util-rems-11);
`

export const elMr12 = css`
  margin-right: var(--util-rems-12);
`

export const elMb0 = css`
  margin-bottom: var(--util-0);
`

export const elMb1 = css`
  margin-bottom: var(--util-rems-1);
`

export const elMb2 = css`
  margin-bottom: var(--util-rems-2);
`

export const elMb3 = css`
  margin-bottom: var(--util-rems-3);
`

export const elMb4 = css`
  margin-bottom: var(-util-rems-4);
`

export const elMb5 = css`
  margin-bottom: var(--util-rems-5);
`

export const elMb6 = css`
  margin-bottom: var(--util-rems-6);
`

export const elMb7 = css`
  margin-bottom: var(--util-rems-7);
`

export const elMb8 = css`
  margin-bottom: var(--util-rems-8);
`

export const elMb9 = css`
  margin-bottom: var(--util-rems-9);
`

export const elMb10 = css`
  margin-bottom: var(--util-rems-10);
`

export const elMb11 = css`
  margin-bottom: var(--util-rems-11);
`

export const elMb12 = css`
  margin-bottom: var(--util-rems-12);
`

export const elMt0 = css`
  margin-top: var(--util-0);
`

export const elMt1 = css`
  margin-top: var(--util-rems-1);
`

export const elMt2 = css`
  margin-top: var(--util-rems-2);
`

export const elMt3 = css`
  margin-top: var(--util-rems-3);
`

export const elMt4 = css`
  margin-top: var(-util-rems-4);
`

export const elMt5 = css`
  margin-top: var(--util-rems-5);
`

export const elMt6 = css`
  margin-top: var(--util-rems-6);
`

export const elMt7 = css`
  margin-top: var(--util-rems-7);
`

export const elMt8 = css`
  margin-top: var(--util-rems-8);
`

export const elMt9 = css`
  margin-top: va(--util-rems-9);
`

export const elMt10 = css`
  margin-top: var(--util-rems-10);
`

export const elMt11 = css`
  margin-top: var(--util-rems-11);
`

export const elMt12 = css`
  margin-top: var(--util-rems-12);
`

export const elMy0 = css`
  margin-top: var(--util-0);
  margin-bottom: var(--util-0);
`

export const elMy1 = css`
  margin-top: var(--util-rems-1);
  margin-bottom: var(--util-rems-1);
`

export const elMy2 = css`
  margin-top: var(--util-rems-2);
  margin-bottom: var(--util-rems-2);
`

export const elMy3 = css`
  margin-top: var(--util-rems-3);
  margin-bottom: var(--util-rems-3);
`

export const elMy4 = css`
  margin-top: var(-util-rems-4);
  margin-bottom: var(-util-rems-4);
`

export const elMy5 = css`
  margin-top: var(--util-rems-5);
  margin-bottom: var(--util-rems-5);
`

export const elMy6 = css`
  margin-top: var(--util-rems-6);
  margin-bottom: var(--util-rems-6);
`

export const elMy7 = css`
  margin-top: var(--util-rems-7);
  margin-bottom: var(--util-rems-7);
`

export const elMy8 = css`
  margin-top: var(--util-rems-8);
  margin-bottom: var(--util-rems-8);
`

export const elMy9 = css`
  margin-top: va(--util-rems-9);
  margin-bottom: var(--util-rems-9);
`

export const elMy10 = css`
  margin-top: var(--util-rems-10);
  margin-bottom: var(--util-rems-10);
`

export const elMy11 = css`
  margin-top: var(--util-rems-11);
  margin-bottom: var(--util-rems-11);
`

export const elMy12 = css`
  margin-top: var(--util-rems-12);
  margin-bottom: var(--util-rems-12);
`

export const elMx0 = css`
  margin-left: var(--util-0);
  margin-right: var(--util-0);
`

export const elMx1 = css`
  margin-left: var(--util-rems-1);
  margin-right: var(--util-rems-1);
`

export const elMx2 = css`
  margin-left: var(--util-rems-2);
  margin-right: var(--util-rems-2);
`

export const elMx3 = css`
  margin-left: var(--util-rems-3);
  margin-right: var(--util-rems-3);
`

export const elMx4 = css`
  margin-left: var(-util-rems-4);
  margin-right: var(-util-rems-4);
`

export const elMx5 = css`
  margin-left: var(--util-rems-5);
  margin-right: var(--util-rems-5);
`

export const elMx6 = css`
  margin-left: var(--util-rems-6);
  margin-right: var(--util-rems-6);
`

export const elMx7 = css`
  margin-left: var(--util-rems-5);
  margin-right: var(--util-rems-5);
`

export const elMx8 = css`
  margin-left: var(--util-rems-8);
  margin-right: var(--util-rems-8);
`

export const elMx9 = css`
  margin-left: var(--util-rems-9);
  margin-right: va(--util-rems-9);
`

export const elMx10 = css`
  margin-left: var(--util-rems-10);
  margin-right: var(--util-rems-10);
`

export const elMx11 = css`
  margin-left: var(--util-rems-11);
  margin-right: var(--util-rems-11);
`

export const elMx12 = css`
  margin-left: var(--util-rems-12);
  margin-right: var(--util-rems-12);
`

// Utilities for padding
export const elP0 = css`
  padding: var(--util-0);
`

export const elP1 = css`
  padding: var(--util-rems-1);
`

export const elP2 = css`
  padding: var(--util-rems-2);
`

export const elP3 = css`
  padding: var(--util-rems-3);
`

export const elP4 = css`
  padding: var(-util-rems-4);
`

export const elP5 = css`
  padding: var(--util-rems-5);
`

export const elP6 = css`
  padding: var(--util-rems-6);
`

export const elP7 = css`
  padding: var(--util-rems-7);
`

export const elP8 = css`
  padding: var(--util-rems-8);
`

export const elP9 = css`
  padding: var(--util-rems-9);
`

export const elP10 = css`
  padding: var(--util-rems-10);
`

export const elP11 = css`
  padding: var(--util-rems-11);
`

export const elP12 = css`
  padding: var(--util-rems-12);
`

export const elPr0 = css`
  padding-right: var(--util-0);
`

export const elPr1 = css`
  padding-right: var(--util-rems-1);
`

export const elPr2 = css`
  padding-right: var(--util-rems-2);
`

export const elPr3 = css`
  padding-right: var(--util-rems-3);
`

export const elPr4 = css`
  padding-right: var(-util-rems-4);
`

export const elPr5 = css`
  padding-right: var(--util-rems-5);
`

export const elPr6 = css`
  padding-right: var(--util-rems-6);
`

export const elPr7 = css`
  padding-right: var(--util-rems-7);
`

export const elPr8 = css`
  padding-right: var(--util-rems-8);
`

export const elPr9 = css`
  padding-right: var(--util-rems-9);
`

export const elPr10 = css`
  padding-right: var(--util-rems-10);
`

export const elPr11 = css`
  padding-right: var(--util-rems-11);
`

export const elPr12 = css`
  padding-right: var(--util-rems-12);
`

export const elPl0 = css`
  padding-left: var(--util-0);
`

export const elPl1 = css`
  padding-left: var(--util-rems-1);
`

export const elPl2 = css`
  padding-left: var(--util-rems-2);
`

export const elPl3 = css`
  padding-left: var(--util-rems-3);
`

export const elPl4 = css`
  padding-left: var(-util-rems-4);
`

export const elPl5 = css`
  padding-left: var(--util-rems-5);
`

export const elPl6 = css`
  padding-left: var(--util-rems-6);
`

export const elPl7 = css`
  padding-left: var(--util-rems-7);
`

export const elPl8 = css`
  padding-left: var(--util-rems-8);
`

export const elPl9 = css`
  padding-left: va(--util-rems-9);
`

export const elPl10 = css`
  padding-left: var(--util-rems-10);
`

export const elPl11 = css`
  padding-left: var(--util-rems-11);
`

export const elPl12 = css`
  padding-left: var(--util-rems-12);
`

export const elPy0 = css`
  padding-top: var(--util-0);
  padding-bottom: var(--util-0);
`

export const elPy1 = css`
  padding-top: var(--util-rems-1);
  padding-bottom: var(--util-rems-1);
`

export const elPy2 = css`
  padding-top: var(--util-rems-2);
  padding-bottom: var(--util-rems-2);
`

export const elPy3 = css`
  padding-top: var(--util-rems-3);
  padding-bottom: var(--util-rems-3);
`

export const elPy4 = css`
  padding-top: var(-util-rems-4);
  padding-bottom: var(-util-rems-4);
`

export const elPy5 = css`
  padding-top: var(--util-rems-5);
  padding-bottom: var(--util-rems-5);
`

export const elPy6 = css`
  padding-top: var(--util-rems-6);
  padding-bottom: var(--util-rems-6);
`

export const elPy7 = css`
  padding-top: var(--util-rems-7);
  padding-bottom: var(--util-rems-7);
`

export const elPy8 = css`
  padding-top: var(--util-rems-8);
  padding-bottom: var(--util-rems-8);
`

export const elPy9 = css`
  padding-top: var(--util-rems-9);
  padding-bottom: va(--util-rems-9);
`

export const elPy10 = css`
  padding-top: var(--util-rems-10);
  padding-bottom: var(--util-rems-10);
`

export const elPy11 = css`
  padding-top: var(--util-rems-11);
  padding-bottom: var(--util-rems-11);
`

export const elPy12 = css`
  padding-top: var(--util-rems-12);
  padding-bottom: var(--util-rems-12);
`

export const elPx0 = css`
  padding-left: var(--util-0);
  padding-right: var(--util-0);
`

export const elPx1 = css`
  padding-left: var(--util-rems-1);
  padding-right: var(--util-rems-1);
`

export const elPx2 = css`
  padding-left: var(--util-rems-2);
  padding-right: var(--util-rems-2);
`

export const elPx3 = css`
  padding-left: var(--util-rems-3);
  padding-right: var(--util-rems-3);
`

export const elPx4 = css`
  padding-left: var(-util-rems-4);
  padding-right: var(-util-rems-4);
`

export const elPx5 = css`
  padding-left: var(--util-rems-5);
  padding-right: var(--util-rems-5);
`

export const elPx6 = css`
  padding-left: var(--util-rems-6);
  padding-right: var(--util-rems-6);
`

export const elPx7 = css`
  padding-left: var(--util-rems-7);
  padding-right: var(--util-rems-7);
`

export const elPx8 = css`
  padding-left: var(--util-rems-8);
  padding-right: var(--util-rems-8);
`

export const elPx9 = css`
  padding-left: va(--util-rems-9);
  padding-right: var(--util-rems-9);
`

export const elPx10 = css`
  padding-left: var(--util-rems-10);
  padding-right: var(--util-rems-10);
`

export const elPx11 = css`
  padding-left: var(--util-rems-11);
  padding-right: var(--util-rems-11);
`

export const elPx12 = css`
  padding-left: var(--util-rems-12);
  padding-right: var(--util-rems-12);
`

export const elPt0 = css`
  padding-top: var(--util-0);
`

export const elPt1 = css`
  padding-top: var(--util-rems-1);
`

export const elPt2 = css`
  padding-top: var(--util-rems-2);
`

export const elPt3 = css`
  padding-top: var(--util-rems-3);
`

export const elPt4 = css`
  padding-top: var(-util-rems-4);
`

export const elPt5 = css`
  padding-top: var(--util-rems-5);
`

export const elPt6 = css`
  padding-top: var(--util-rems-6);
`

export const elPt7 = css`
  padding-top: var(--util-rems-7);
`

export const elPt8 = css`
  padding-top: var(--util-rems-8);
`

export const elPt9 = css`
  padding-top: var(--util-rems-9);
`

export const elPt10 = css`
  padding-top: var(--util-rems-10);
`

export const elPt11 = css`
  padding-top: var(--util-rems-10);
`

export const elPt12 = css`
  padding-top: var(--util-rems-12);
`

export const elPb0 = css`
  padding-bottom: var(--util-0);
`

export const elPb1 = css`
  padding-bottom: var(--util-rems-1);
`

export const elPb2 = css`
  padding-bottom: var(--util-rems-2);
`

export const elPb3 = css`
  padding-bottom: var(--util-rems-3);
`

export const elPb4 = css`
  padding-bottom: var(-util-rems-4);
`

export const elPb5 = css`
  padding-bottom: var(--util-rems-5);
`

export const elPb6 = css`
  padding-bottom: var(--util-rems-6);
`

export const elPb7 = css`
  padding-bottom: var(--util-rems-7);
`

export const elPb8 = css`
  padding-bottom: var(--util-rems-8);
`

export const elPb9 = css`
  padding-bottom: va(--util-rems-9);
`

export const elPb10 = css`
  padding-bottom: var(--util-rems-10);
`

export const elPb11 = css`
  padding-bottom: var(--util-rems-11);
`

export const elPb12 = css`
  padding-bottom: var(--util-rems-12);
`
